<template lang="">
  <!-- BBS : FILTER -->
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
    
    <div class="rgt_area">
      <a href="#none" class="bt_base primary">엑셀 다운로드</a>
    </div>
  </div>

  <div class="bbs_list">
    <div class="bbs_info">
      <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ accountListCount }}</div>
    </div>

    <table class="bbs_tbl">
      <colgroup>
        <col style="width:60px">
        <col style="width:200px">
        <col style="width:120px">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:auto">
      </colgroup>
      <thead>
        <tr>
          <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name=""><label for=""></label></span></th>
          <th scope="col">아이디</th>
          <th scope="col">이름</th>
          <th scope="col">이메일</th>
          <th scope="col">설명</th>
          <th scope="col">환불계좌번호</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(account, index) in accountList"
        >
        <td>
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox" 
                :value="account.accountSeq"
                v-model="selectedAccounts"
              >
              <label for=""></label>
            </span>
          </td>
          <td><a href="#none" class="link">{{ account.username }}</a></td>
          <td>{{ account.name }}</td>
          <td>{{ account.email }}</td>
          <td>{{ account.description }}</td>
          <td>{{ account.bankName }}, {{ account.bankNumber }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click=deleteSelectedAccounts>회원 삭제</button>
      <button type="button" class="bt_base primary large_h" @click="createAccount">회원 등록</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminAccountModule = 'adminAccountModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedAccounts: [],
      root: 'NORMAL',

      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '아이디', value: 'username' },
        { name: '이름', value: 'name' },
      ],
      searchType: '',
      searchWord: ''
    }
  },

  methods: {
    ...mapActions(adminAccountModule, [
      'requestAccountList',
      'requestDeleteAccounts'
    ]),

    createAccount () {
      this.$router.push({ name: "AccountManageCreatePage" })
    },

    totalPages() {
      return Math.ceil(this.accountListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      this.selectedAccounts = []
      const {currentPage, searchType, searchWord, root} = this
      await this.requestAccountList({currentPage, searchType, searchWord, root})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.accountListCount)) {
        currentLastCount = this.accountListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedAccounts = []
        for (const account of this.accountList) {
          this.selectedAccounts.push(account.accountSeq)
        }
      } else {
        this.selectedAccounts = []
      }
    },

    async deleteSelectedAccounts() {
      if (this.selectedAccounts.length === 0) {
        alert('선택된 계정이 없습니다');
        return;
      }

      const { searchType, searchWord, root, currentPage } = this;
      const fetchAccounts = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
        const params = { currentPage: page, searchType: type, searchWord: word, root };
        await this.requestAccountList(params);
        if (isReset) {
          this.searchType = 'all';
        }
      };

      await this.requestDeleteAccounts(this.selectedAccounts);
      this.selectedAccounts = [];

      await fetchAccounts(currentPage);

      if (this.accountList.length === 0 && this.currentPage > 1) {
        this.currentPage -= 1;
        await fetchAccounts(this.currentPage);
      }

      if (this.accountList.length === 0 || this.currentPage === 1) {
        this.currentPage = 1;
        this.searchType = '';
        this.searchWord = '';
        await fetchAccounts(1, '', '', true);
      }
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord, root} = this
      await this.requestAccountList({currentPage, searchType, searchWord, root})
    }
  },

  computed: {
    ...mapState(adminAccountModule, [
      'accountList',
      'accountListCount'
    ])
  },

  async mounted () {
    const {currentPage, searchType, searchWord, root} = this
    await this.requestAccountList({currentPage, searchType, searchWord, root})
    this.searchType = 'all'
  }
}
</script>
<style lang="">
    
</style>